import { jsx as a } from "react/jsx-runtime";
import { InputLabelWrapper as i } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { c as b } from "../../index-C3-ZVs5E.js";
import { useCallback as f } from "react";
import { Textarea as y } from "../textarea/Textarea.component.js";
import { TextareaThemeEnum as _ } from "../textarea/types.js";
import '../../assets/LabeledTextarea.css';const u = "_label_1goix_2", x = "_secondary_1goix_2", e = {
  label: u,
  secondary: x
}, k = ({
  id: l,
  labelText: n,
  error: c,
  textareaTheme: o,
  textareaSize: r,
  containerClassName: m,
  className: t,
  ...s
}) => {
  const p = f(
    (d) => /* @__PURE__ */ a(
      y,
      {
        ...s,
        ...d,
        textareaTheme: o,
        textareaSize: r
      }
    ),
    [o, r, s]
  );
  return /* @__PURE__ */ a(
    i,
    {
      labelText: n,
      id: l,
      containerClassName: m,
      error: c,
      children: p,
      className: b(e.label, t, {
        [e.secondary]: o === _.secondary
      })
    }
  );
};
export {
  k as LabeledTextArea
};
